class Str {
  static only(string, length = 15) {
    return String(string).length > length
      ? string.substring(0, length - 3) + "..."
      : string;
  }
}

export default Str;